var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-date-picker',_vm._g(_vm._b({attrs:{"no-title":"","scrollable":""}},'v-date-picker',{ ..._vm.$attrs, ..._vm.$props },false),{ ..._vm.$listeners }))
}
var staticRenderFns = []

export { render, staticRenderFns }